import React, {useState} from 'react';
import Tabs from "../../../components/Tabs";
import ContentTop from "../../../components/ContentTop";
import Table from "./Table";
import Page4 from "./Page4";

const ZarafshonSahifa = () => {
    const [toggle, setToggle] = useState(4)
    const tabs = [
        {title: "Diagramma va Jadval", id: 4, type: "text" },
        {title: "location", id: 1, type: "location" },
    ]
    const [date, setDate] = useState(new Date().toISOString().slice(0,10))
    const [ldate, setLdate] = useState(date)
    return (
        <div>
            <ContentTop>
                <ul className="content-top-left suv-omborlari">
                    <li>Zarafshon daryosi balansi </li>
                    <div>
                        <Tabs toggle={toggle} setToggle={setToggle} tabs={tabs} />
                    </div>
                </ul>
                <ul className="content-top-right">
                    <input type="date" className="form-control form-control-sm" onChange={e=>setLdate(e.target.value)} value={ldate}/>
                    &nbsp;&nbsp;&nbsp;
                    <button className="btn btn-outline-primary btn-sm" onClick={()=>setDate(ldate)}>Ok</button>
                </ul>
            </ContentTop>
            <div className="tabs-content table-box extra-tab-css">
                <div className="tabs-content-item active">
                    {
                        toggle == 1 ?<Page4 date={date}/> : <Table date={date}/>
                    }
                </div>
            </div>
        </div>
    );
};

export default ZarafshonSahifa;